import apiClient from '@/services/api-client';

export const getInvoices = async (params) => {
    try {
        const response = await apiClient.get('/invoice/list', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
};


export const addDraftInvoice = async () => {
    try {
        const response = await apiClient.post('/invoice/add');
        return response.data;
    } catch (error) {
        console.error('Error creating draft invoice:', error);
        throw error;
    }
};

export const getInvoiceBySpecialRef = async (specialRef) => {
    try {
        const response = await apiClient.get('/invoice/get/special-ref', {
            params: { specialRef }
        });
        return response.data; // InvoiceResponseDTO
    } catch (error) {
        console.error(`Error fetching invoice ${specialRef}:`, error);
        throw error;
    }
};

export const addInvoiceLine = async (specialRef, item) => {
    try {
        const response = await apiClient.post('/invoice/add/invoice-line', item, {
            params: { specialRef }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error adding invoice line to ${specialRef}:`, error);
        throw error;
    }
};


export const setInvoiceCustomer = async (specialRef, customerId) => {
    try {
        const response = await apiClient.post('/invoice/set-customer', null, {
            params: { specialRef, customerId }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error setting customer for invoice ${specialRef}:`, error);
        throw error;
    }
};


export const saveDeposit = async (specialRef, depositAmount) => {
    try {
        const response = await apiClient.post('/invoice/set-deposit', null, {
            params: { specialRef, depositAmount }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error setting deposit amount for invoice ${specialRef}:`, error);
        throw error;
    }
};



export const removeInvoiceLine = async (specialRef, invoiceLineId) => {
    try {
        const response = await apiClient.post('/invoice/remove/invoice-line', null, {
            params: { specialRef, invoiceLineId }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error removing invoice line ${invoiceLineId} from invoice ${specialRef}:`, error);
        throw error;
    }
};


export const addTaxes = async (specialRef, taxStamp) => {
    try {
        const response = await apiClient.post('/invoice/add/taxes', null, {
            params: { specialRef, taxStamp }
        });
        return response.data;
    } catch (error) {
        console.error(`Error adding taxes to invoice ${specialRef}:`, error);
        throw error;
    }
};


export const submitInvoice = async (specialRef, note, projectName) => {
    try {
        const response = await apiClient.post('/invoice/submit', null, {
            params: { specialRef, note, projectName }
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting invoice:', error);
        throw error;
    }
};


export const generateInvoiceFromQuote = async (orderId) => {
    try {
        const response = await apiClient.get('/invoice/invoiced-order',{
            params: { orderId }
        });
        return response.data;
    } catch (error) {
        console.error('Error to convert quote to invoice:', error);
        throw error;
    }
};


export const generateInvoiceFromWorkTrackingSheet = async (params) => {
  try {
    const response = await apiClient.get('/invoice/invoiced-work-tracking', {
      params
    });

    return response.data;
  } catch (error) {
    console.error('Error to convert work tracking sheet to invoice:', error);
    throw error;
  }
};


export const getVatRate = async () => {
    try {
        const response = await apiClient.get('/invoice/vat-rate/list');
        return response.data;
    } catch (error) {
        console.error('Error to get vat rate list :', error);
        throw error;
    }
};

// ttn = true: facture TTN (signée, avec le QR code TTN) ; false: relevé (sans QR code)
export const downloadInvoiceFile = async (invoiceId, ttn = false) => {
  try {
    const response = await apiClient.get('/invoice/generate', {
      params: { invoiceId, ttn },
      responseType: 'blob'
    });

    const pdfBlob = new Blob([response.data], {
      type: 'application/pdf'
    });

    const pdfUrl = window.URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, '_blank');

    setTimeout(() => {
      window.URL.revokeObjectURL(pdfUrl);
    }, 10000);

  } catch (error) {
    console.error('Error downloading invoice:', error);
    throw error;
  }
};


export const deleteInvoice = async (params) => {
    try {
        const response = await apiClient.get('/invoice/delete' , {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft invoice:', error);
        throw error;
    }
};


export const addPartialPayment = async (paymentInvoiceDetailsRequest ,params) => {
    try {
        const response = await apiClient.post('/invoice/add-partial-payment' , paymentInvoiceDetailsRequest, {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft invoice:', error);
        throw error;
    }
};

export const previewPayAllByYear = async (year) => {
    const response = await apiClient.get('/invoice/bulk-payment/preview', {params: {year}});
    return response.data;
};

export const payAllByYear = async (params) => {
    const response = await apiClient.post('/invoice/bulk-payment/pay-all', null, {params});
    return response.data;
};

export const getPaymentConfiguration = async () => {
    try {
        const response = await apiClient.get('/invoice/payment-configuration');
        return response.data;
    } catch (error) {
        console.error('Error loading payment configuration:', error);
        throw error;
    }
};


export const markInvoicePaid = async (params) => {
    try {
        const response = await apiClient.get('/invoice/markInvoicePaid' , {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft invoice:', error);
        throw error;
    }
};


export const findPaymentDetails = async (params) => {
    try {
        const response = await apiClient.get('/invoice/details' , {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft invoice:', error);
        throw error;
    }
};

/**
 * Le serveur répond 400 { message } avec le texte français de la clé d'erreur, traduit via
 * messages/error.properties (ex. ttn.invoice.not.signed -> « Signez la facture avant de l'envoyer à TTN. »).
 * Les regex reconnaissent ce texte traduit ; la clé brute reste acceptée en secours.
 */
const TTN_API_ERRORS = {
    'ttn.invoice.not.signed': /ttn\.invoice\.not\.signed|signez la facture|pas (été )?signée|non signée/i,
    'ttn.invoice.already.signed': /ttn\.invoice\.already\.signed|déjà signée/i,
};

export const isTtnApiError = (error, key) =>
    error?.response?.status === 400 && TTN_API_ERRORS[key]?.test(error.response.data?.message || '') === true;

/** Prépare la signature : passe la facture en TO_SIGN (depuis NEW, TO_SIGN, FAILED, REJECTED ou RETRY sans signature stockée). */
export const signInvoiceForTtn = async (invoiceId) => {
    try {
        const response = await apiClient.post('/invoice/sign-ttn', null, {
            params: { invoiceId }
        });
        return response.data; // updated invoice DTO with ttnStatus (TO_SIGN) / ttnMessage
    } catch (error) {
        console.error(`Error preparing TTN signature of invoice ${invoiceId}:`, error);
        throw error;
    }
};

/** Envoie à TTN le XML signé déjà stocké (depuis SIGNED ou RETRY uniquement). */
export const sendInvoiceToTtn = async (invoiceId) => {
    try {
        const response = await apiClient.post('/invoice/send-ttn', null, {
            params: { invoiceId }
        });
        return response.data; // updated invoice DTO with ttnStatus (SENT / RETRY / FAILED / REJECTED) / ttnMessage
    } catch (error) {
        console.error(`Error sending invoice ${invoiceId} to TTN:`, error);
        throw error;
    }
};

export const checkInvoiceTtnStatus = async (invoiceId) => {
    try {
        const response = await apiClient.post('/invoice/check-ttn-status', null, {
            params: { invoiceId }
        });
        return response.data; // updated invoice DTO with ttnStatus / ttnMessage / ttnReference / ttnCheckedAt
    } catch (error) {
        console.error(`Error checking TTN status of invoice ${invoiceId}:`, error);
        throw error;
    }
};

export const getInvoiceTeif = async (invoiceId) => {
    try {
        const response = await apiClient.get(`/invoice/ttn/${invoiceId}/teif`, { responseType: 'text' });
        return response.data; // unsigned TEIF XML
    } catch (error) {
        console.error(`Error fetching TEIF of invoice ${invoiceId}:`, error);
        throw error;
    }
};

/** Dépose le XML signé par l'agent ; 422 { message } si la signature est invalide. */
export const submitSignedTeif = async (invoiceId, xml) => {
    try {
        const response = await apiClient.post(`/invoice/ttn/${invoiceId}/signed`, xml, {
            headers: { 'Content-Type': 'application/xml' }
        });
        return response.data; // updated invoice DTO with ttnStatus SIGNED (not sent to TTN yet)
    } catch (error) {
        console.error(`Error submitting signed TEIF of invoice ${invoiceId}:`, error);
        throw error;
    }
};
